import { BlindConfigService } from "../../../Common/BlindConfigurations/BlindConfigService";

export class SsrVersionedService extends BlindConfigService {

}